export enum View {
  PAST = "past",
  TODAY = "today",
  FUTURE = "future",
}
